import axios from "axios";
import authentication from "@/authentication";

export default {
  baseUrl: process.env.VUE_APP_API_CALLS_SERVICE_BASE,
  async getPackageIds(trackingNumbers) {
    await authentication.isAuthenticated();
    return axios
      .post(`${this.baseUrl}/GetPackageIds`, trackingNumbers, {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      })
      .then(response => {
        return response.data;
      });
  },
  async sendCallBroadcast(data) {
    await authentication.isAuthenticated();
    return axios
      .post(`${this.baseUrl}/SendCallBroadcast`, data, {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      })
      .then(response => {
        return response.data;
      });
  }
};
